import { render, staticRenderFns } from "./ValorantBindingPage.vue?vue&type=template&id=f582cd68&scoped=true"
import script from "./ValorantBindingPage.vue?vue&type=script&lang=js"
export * from "./ValorantBindingPage.vue?vue&type=script&lang=js"
import style0 from "./ValorantBindingPage.vue?vue&type=style&index=0&id=f582cd68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f582cd68",
  null
  
)

export default component.exports